// extracted by mini-css-extract-plugin
export default {"recos":"z7-z","productCardOverride":"A7-z","rowHasBadge":"B7-z"};